import * as React from 'react';
import { HeaderFeature } from '@app/src/common/header';
import { FooterFeature } from '@app/src/common/footer';
import {
  ImgDes,
  ImgMob,
  Item,
  ItemNumber,
  List,
  Text,
  Title,
  Title2,
  Title3,
  TopSection,
  Wrapper
} from './styled';
import { PublicationClosingDates } from '@app/src/views/HelpCenter/components/PublicationClosingDates';

const DOMAIN_CDE = process.env.URL_DOMAIN_ELEMENTS

export const FrequentQuestions:React.FC = () => (
  <React.Fragment>
    <HeaderFeature/>
    <TopSection>
      <Title>Preguntas Frecuentes</Title>
      <Wrapper>
        <Title2>Clasificados print</Title2>
        <Title3>¿Cómo publicar un aviso?</Title3>
        <Text>Para publicar un aviso lo puedes hacer directamente desde la página web o con nuestros asesores de venta.</Text>

        <Title3>WEB</Title3>
        <Text>Para que puedas publicar tus avisos, tienes dos opciones: escribirnos a <a href='mailto:fonoavisos@comercio.com.pe.'>fonoavisos@comercio.com.pe.</a> o hacerlo por la web eligiendo la categoría en la que deseas publicar y sigue los pasos que se te indican.</Text>

        <Title3>¿Cuáles son las fechas de publicación?</Title3>
        <Text>Recomendamos realizar el pago con tiempo de anticipación, para que los avisos puedan ser procesados sin ningún inconveniente.</Text>
        <PublicationClosingDates/>

        <Title3>¿Qué características tiene mi aviso?</Title3>
        <List>
          <Item>El costo base de tu aviso tiene 12 palabras incluidas con 12 caracteres cada una.</Item>
          <Item>Se admiten avisos de máximo 20 palabras.</Item>
          <Item>Cada palabra adicional te cuesta  S/. 3.00 soles.</Item>
          <Item>Puedes contratar <strong>extracargos</strong> para resaltar de mejor manera tu aviso.</Item>
          <Item>Los avisos son a disponibilidad de espacio de cada edición.</Item>
        </List>

        <Title3>¿Cómo edito la información de mi aviso?</Title3>
        <Text>La información de los avisos impresos no puede ser editados, por ello le recomendamos revisar la vista previa de su aviso antes de realizar el pago. Ya que, al realizar el pago usted brinda la conformidad del mismo.</Text>

        <Title3>¿Cómo puedo cotizar el precio de mi aviso?</Title3>
        <Text>Para que puedas cotizar tu aviso, primero debes elegir la sección en la que deseas publicar, seguir todos los pasos hasta que te salga el monto de tu aviso o de lo contrario, escríbenos a <a href='mailto:fonoavisos@comercio.com.pe.'>fonoavisos@comercio.com.pe</a>.</Text>

        <Title3>¿Qué hacer si mi aviso no fue publicado?</Title3>
        <Text>Escríbenos a nuestro correo <a href='mailto:postventa@comercio.com.pe'>postventa@comercio.com.pe</a> detallando el incidente. En el asunto escribir: AVISO NO PUBLICADO - WEB DE CLASIFICADOS. Considerar en el mensaje su número de RUC o DNI, la fecha que debió salir publicado y el periódico.</Text>

        <Title3>¿Qué hacer si mi aviso fue publicado con información errónea?</Title3>
        <Text>Si usted dio conformidad a la vista previa de su aviso y este es el mismo aviso que se publicó, no procede ningún reclamo o republicación, ya que al realizar el pago usted da la conformidad de la información del aviso.</Text>
        <Text>Si el aviso se publicó diferente a la vista previa que se le envió, por favor escríbanos a <a href='mailto:postventa@comercio.com.pe'>postventa@comercio.com.pe</a> detallando su incidente. En el asunto escribir: ERROR EN AVISO PUBLICADO - WEB DE CLASIFICADOS.</Text>

        <Title2>Paquetes de avisos</Title2>

        <Title3>¿Qué es un paquete de avisos?</Title3>
        <Text>Un paquete de avisos es un conjunto de avisos adquiridos a un precio especial y para una categoría específica, que podrán ser publicados en un periodo no mayor a dos meses en las fechas indicadas por el cliente. Todos los paquetes actualmente cuentan con <strong>extracargos</strong> que podrás usar para destacar tus avisos en el día de publicación solicitado. Los avisos de cualquier paquete contratado tienen un <strong>límite de 12 palabras por cada aviso</strong>, sin opción a incluir palabras adicionales.</Text>

        <Title3>¿Cómo comprar un paquete de avisos?</Title3>
        <Text>Inicia sesión o regístrate.</Text>
        <ImgDes src={`${DOMAIN_CDE}/legal/images/Picture6.png`}></ImgDes>
        <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture6_mobile.png`}></ImgMob>
        <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture6_1_mobile.png`}></ImgMob>
        <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture6_2_mobile.png`}></ImgMob>
        <Text>Dirígete a la esquina superior derecha y selecciona VER PAQUETES</Text>
        <ImgDes src={`${DOMAIN_CDE}/legal/images/Picture7.png`}></ImgDes>
        <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture7_mobile.png`}></ImgMob>
        <Text>Elige la sección donde te gustaría publicar para ver los paquetes disponibles.</Text>
        <ImgDes src={`${DOMAIN_CDE}/legal/images/Picture8.png`}></ImgDes>
        <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture8_mobile.png`}></ImgMob>
        <Text>Lee con atención las características, elige tu paquete de avisos ideal y dale clic a “CONTRATAR”</Text>
        <ImgDes src={`${DOMAIN_CDE}/legal/images/Picture9.png`}></ImgDes>
        <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture9_mobile.png`}></ImgMob>
        <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture9_1_mobile.png`}></ImgMob>
        <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture9_2_mobile.png`}></ImgMob>
        <Text>Te redirigiremos a nuestra plataforma de pagos donde tendrás que ingresar tus datos personales y se detallará el total a pagar.</Text>
        <ImgDes src={`${DOMAIN_CDE}/legal/images/Picture10.png`}></ImgDes>
        <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture10_mobile.png`}></ImgMob>

        <Title3>¿Cómo publico los avisos impresos de mi paquete adquirido?</Title3>
        <List>
          <ItemNumber>Inicia sesión.</ItemNumber>
          <ImgDes src={`${DOMAIN_CDE}/legal/images/Picture11.png`}></ImgDes>
          <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture11_mobile.png`}></ImgMob>
          <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture11_1_mobile.png`}></ImgMob>
          <ItemNumber>Dirígete a la esquina superior derecha, clickea en la flechita al costado de tu nombre y posteriormente en “MI CUENTA”. Aquí podrás observar tus avisos publicados y la cantidad pendiente por programar.</ItemNumber>
          <ImgDes src={`${DOMAIN_CDE}/legal/images/Picture12.png`}></ImgDes>
          <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture12_mobile.png`}></ImgMob>
          <ItemNumber>Selecciona “AVISOS DISPONIBLES” y podrás visualizar los avisos que aún tienes pendiente de programar.</ItemNumber>
          <ImgDes src={`${DOMAIN_CDE}/legal/images/Picture13.png`}></ImgDes>
          <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture13_mobile.png`}></ImgMob>
          <ItemNumber>Elegir el paquete que quieras consumir y selecciona “Publicar”</ItemNumber>
          <ImgDes src={`${DOMAIN_CDE}/legal/images/Picture14.png`}></ImgDes>
          <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture14_mobile.png`}></ImgMob>
          <ItemNumber>Deberás completar los campos que te solicitamos (estos variarán dependiendo de la categoría contratada del paquete). En este paso incluirás el texto del aviso y detallarás fechas de publicación. ¡No olvides que puedes elegir usar tus extracargos disponibles!</ItemNumber>
          <ImgDes src={`${DOMAIN_CDE}/legal/images/Picture15.png`}></ImgDes>
          <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture15_mobile.png`}></ImgMob>
          <ItemNumber>Finalmente deberás confirmar la vista previa de tu aviso y clickear en “Publicar”. ¡Recuerda que una vez programada la publicación es imposible editar el contenido del aviso!</ItemNumber>
          <ImgDes src={`${DOMAIN_CDE}/legal/images/Picture16.png`}></ImgDes>
          <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture16_mobile.png`}></ImgMob>
          <br/>
          <img src={`${DOMAIN_CDE}/legal/images/Picture17.png`}></img>
        </List>

        <Title3>¿Cómo veo el detalle de mi paquete de avisos comprado?</Title3>
        <List>
          <ItemNumber>Inicia sesión.</ItemNumber>
          <ImgDes src={`${DOMAIN_CDE}/legal/images/Picture11.png`}></ImgDes>
          <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture11_mobile.png`}></ImgMob>
          <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture11_1_mobile.png`}></ImgMob>
          <ItemNumber>Dirígete a la esquina superior izquierda, clickea el botón MENÚ y posteriormente “MI CUENTA”. Aquí podrás observar tus avisos publicados y la cantidad pendiente por programar.</ItemNumber>
          <ImgDes src={`${DOMAIN_CDE}/legal/images/Picture12.png`}></ImgDes>
          <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture12_mobile.png`}></ImgMob>
          <ItemNumber>Selecciona “AVISOS DISPONIBLES” y podrás visualizar todos los avisos que aún tienes pendiente de programar.</ItemNumber>
          <ImgDes src={`${DOMAIN_CDE}/legal/images/Picture13.png`}></ImgDes>
          <ImgMob src={`${DOMAIN_CDE}/legal/images/Picture13_mobile.png`}></ImgMob>
        </List>

        <Title3>¿Cómo editar un aviso programado?</Title3>
        <Text>No es posible editar los avisos que fueron programados para publicación. Recuerda que antes de programar tu aviso te mostramos la vista previa del contenido y le das tu aprobación.</Text>

        <Title3>¿Cómo eliminar un aviso?</Title3>
        <Text>No es posible eliminar los avisos que fueron programados para publicación, sin embargo, si puedes eliminarlos de tu cuenta como historial, pero esta acción no afectará la publicación ya programada.</Text>
      </Wrapper>
    </TopSection>
    <FooterFeature isDisplay={true} />
  </React.Fragment>
);
